import script from "./text-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./text-input.vue?vue&type=script&lang=ts&setup=true"

import "./text-input.vue?vue&type=style&index=0&id=43af1cec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43af1cec"]])

export default __exports__